/**
 * Invitation Post-Accept Sync
 *
 * Shared browser event helpers for invitation accept side effects.
 *
 * Primary responsibilities:
 * - Broadcast accepted invitation metadata to mounted app stores
 * - Provide a typed listener for workspace/space refresh handlers
 *
 * Dependencies:
 * - Browser CustomEvent API
 */

export const INVITATION_ACCEPTED_EVENT = 'losi:invitation-accepted'

export type InvitationAcceptedEventDetail = {
  workspaceId?: string | null
  spaceId?: string | null
  preserveSelectedWorkspace?: boolean
}

export const dispatchInvitationAccepted = (
  detail: InvitationAcceptedEventDetail
) => {
  if (typeof window === 'undefined') {
    return
  }

  window.dispatchEvent(
    new CustomEvent<InvitationAcceptedEventDetail>(
      INVITATION_ACCEPTED_EVENT,
      {
        detail
      }
    )
  )
}

export const listenInvitationAccepted = (
  handler: (detail: InvitationAcceptedEventDetail) => void
) => {
  if (typeof window === 'undefined') {
    return () => {}
  }

  const listener = (event: Event) => {
    const customEvent = event as CustomEvent<InvitationAcceptedEventDetail>
    handler(customEvent.detail || {})
  }

  window.addEventListener(INVITATION_ACCEPTED_EVENT, listener)

  return () => {
    window.removeEventListener(INVITATION_ACCEPTED_EVENT, listener)
  }
}
